let snapshot = null;
const listeners = new Set();
/** Ephemeral request metadata only; never persists pairing URIs or signatures. */
export const walletRequestStore = {
    getSnapshot: () => snapshot,
    getServerSnapshot: () => null,
    subscribe(listener) {
        listeners.add(listener);
        return () => { listeners.delete(listener); };
    },
};
export function recordWalletRequest(request) {
    snapshot = { ...request, sequence: (snapshot?.sequence ?? 0) + 1 };
    listeners.forEach(listener => listener());
}
